export const LOAD_FAILED_ORDERS = 'load_failed_orders';
export const REMOVE_FAILED_ORDER = 'remove_failed_order';
export const FAILED_ORDERS_LOADED = 'failed_orders_loaded';
export const FAILED_ORDER_REMOVED = 'failed_order_removed';
export const FAILED_ORDERS_SYNC_ERROR = 'failed_orders_sync_error';
export const FAILED_ORDER_REMOVE_ERROR = 'failed_order_remove_error';
export const SYNC_RESENDED_ORDER = 'sync_resended_order';
